import apiClient from './client';

export interface OrderData {
	name: string;
	phone: string;
	email: string;
	zip: string;
	street: string;
	house_number: string;
	product_id: number;
	vehicle_id: number;
	order_day: string;
	order_time: string;
	billing_same: boolean;
	billing_name?: string;
	billing_zip?: string;
	billing_city?: string;
	billing_address?: string;
	google_place_id?: string;
	google_formatted_address?: string;
	google_latitude?: number;
	google_longitude?: number;
	google_address_json?: string;
}

export interface OrderResponse {
	result: string;
	message: string;
	order_id?: number;
	order_number?: string;
	error_code?: string;
	// Per-order token authorizing the thank-you "switch to cash" promo + authoritative amounts.
	switch_token?: string;
	price_gross?: number;
	delivery_fee?: number;
	total?: number;
	payment_method?: string;
}

export interface CashSwitchResponse {
	result: string;
	message?: string;
	total?: number;
	price_gross?: number;
	delivery_fee?: number;
	discount_amount?: number;
	discount_percent?: number;
}

export interface TimeSlot {
	label: string;
	value: string;
	/** Peak-day call-out surcharge in Ft (Intel pricing.peak; 0 / absent = none). */
	peak?: number;
}

export const getAvailableDays = () =>
	apiClient.get<{ data: TimeSlot[] }>('/days');

export const getAvailableHours = (date: string) =>
	apiClient.get<{ data: TimeSlot[] }>('/hours', { params: { date } });

export const createOrder = (data: OrderData) =>
	apiClient.post<OrderResponse>('/order', data);

// Thank-you "switch to cash" promo: apply the 5% cash discount to a just-placed
// order. Authorized by the per-order switch_token issued at order creation.
export const applyCashSwitch = (orderId: number, switchToken: string) =>
	apiClient.post<CashSwitchResponse>('/orderCashSwitch', { order_id: orderId, switch_token: switchToken });
